import React, { useState } from "react"
import CustomCalendar from "../components/DailyCalendarFiles/CustomCalendar/CustomCalendar"
import NavButtons from "../components/schedule-templates/NavButtons"
import NotificationPopup from "../components/DailyCalendarFiles/CustomCalendar/NotificationPopup" // Import NotificationPopup
import { useLocation } from "react-router-dom"

const Schedule = ({ nurseStaffing = true, sidebarOpen }) => {
	const [notification, setNotification] = useState({ visible: false, message: "", success: true })
	const location = useLocation()
	const params = new URLSearchParams(location.search)
	const nurseName = params.get("nurseName")

	return (
		<div>
			<div className={`${sidebarOpen ? "pl-64" : "pl-8"} w-screen`}>
				{notification.visible && (
					<NotificationPopup
						message={notification.message}
						success={notification.success}
						onUndo={() =>
							setNotification({ visible: false, message: "", success: true })
						}
					/>
				)}
				<div className="my-5 flex h-auto sm:h-16 flex-col sm:flex-row items-start sm:items-center justify-between bg-white px-4 sm:px-6 lg:px-8 print-hidden">
					<h1 className="font-bold text-4xl font-manrope text-custom-blue mb-4 sm:mb-0">
						IC Tracker
					</h1>
				</div>

				<div className="bg-white px-4 sm:px-6 lg:px-8 print-hidden">
					<div className="flex flex-wrap items-center gap-x-4 sm:gap-x-6">
						<NavButtons />
					</div>
				</div>

				<main className="py-10 print:block">
					<div className="px-4 sm:px-6 lg:px-8">
						<div className="text-center print:text-left">
							<CustomCalendar
								setNotification={setNotification}
								nurseName={nurseName}
								nurseStaffing={nurseStaffing}
							/>
						</div>
					</div>
				</main>
			</div>
		</div>
	)
}

export default Schedule
